import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { PaperGradientBG } from "../kits/DesignKit";
import ContactIntroSection from "./ContactIntroSection";
import ContactInfoGrid from "./ContactInfoGrid";
import ContactForm from "./ContactForm";
import { Helmet } from "react-helmet";
import { contactSchema } from "./utils/ContactSchema";
import useDesktop from "../hooks/useDesktop";

const CONTACT_TERMINAL_STORAGE_KEY = "contactTerminalTyped:v1";

const Contact = () => {
  const location = useLocation();
  const isDesktop = useDesktop();
  const [contactTypedDone, setContactTypedDone] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.sessionStorage.getItem(CONTACT_TERMINAL_STORAGE_KEY) === "1";
  });
  const shouldAnimateContactTerminal = isDesktop && !contactTypedDone;
  const [introDone, setIntroDone] = useState(false);
  const handleIntroDone = useCallback(() => {
    setIntroDone(true);
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(CONTACT_TERMINAL_STORAGE_KEY, "1");
    }
    setContactTypedDone(true);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.state]);

  useEffect(() => {
    if (shouldAnimateContactTerminal) {
      setIntroDone(false);
      return;
    }
    setIntroDone(true);
  }, [shouldAnimateContactTerminal]);

  const handleSoftScrollToMap = () => {
    const section = document.getElementById("map-section");
    if (section) {
      const topPosition = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: topPosition - 50, behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(contactSchema)}
        </script>
      </Helmet>

      <PaperGradientBG variant="zenBlack">
        <div className="space-y-12 px-4 md:px-12 pb-16">

          <ContactIntroSection
            onTypingDone={handleIntroDone}
            animate={shouldAnimateContactTerminal}
          />

          <ContactInfoGrid
            onShowMapClick={handleSoftScrollToMap}
            show={introDone}
            animate={shouldAnimateContactTerminal}
          />

          <div className="max-w-2xl mx-auto">
            <ContactForm />
          </div>

          {/* Karte */}
          <div
            id="map-section"
            className="max-w-2xl mx-auto rounded-lg border border-[#AC8E66]/20 overflow-hidden shadow-2xl shadow-black/40"
          >
            <div className="flex items-center gap-2 px-4 py-2.5 bg-[#1a1a1a] border-b border-[#AC8E66]/10">
              <span className="w-3 h-3 rounded-full bg-[#ff5f57]" />
              <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
              <span className="w-3 h-3 rounded-full bg-[#28c840]" />
              <span className="ml-3 text-xs text-[#AC8E66] select-none font-mono">map</span>
            </div>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2369.5234!2d10.006891!3d53.553404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b18f1b8e8e8e8f%3A0x0!2sFerdinandstra%C3%9Fe%2015%2C%2020095%20Hamburg!5e0!3m2!1sde!2sde!4v1730000000000!5m2!1sde!2sde"
              allowFullScreen=""
              loading="lazy"
              className="w-full h-72 sm:h-96 border-0 grayscale hover:grayscale-0 transition-all duration-700"
              title="Standortkarte - Ferdinandstraße 15, Hamburg"
            />
          </div>
        </div>
      </PaperGradientBG>
    </>
  );
};

export default Contact;
